<template>
  <swiper
    class="descriptions-mobile-swiper"
    slides-per-view="auto"
    :space-between="16"
  >
    <swiper-slide
      v-for="(slide, index) in slides"
      :key="index"
      class="descriptions-mobile-slide"
      :class="{
        'descriptions-mobile-slide-first': index === 0,
        'descriptions-mobile-slide-last': index === slides.length - 1,
      }"
    >
      <SliderDescription
        :value="slide.value"
        :subtitle="slide.subtitle"
        :description="slide.description"
      />
    </swiper-slide>
  </swiper>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';
import SliderDescription from '@/components/opengym/SliderDescription';
import { getSliderDescriptionSlides } from '@/components/opengym/sliderDescriptionSlides';

export default {
  name: 'SliderDescriptionsMobile',
  components: {
    SliderDescription,
    Swiper,
    SwiperSlide,
  },
  computed: {
    slides() {
      return getSliderDescriptionSlides(this.$t);
    },
  },
};
</script>

<style scoped>
.descriptions-mobile-swiper {
  display: block;
  position: relative;
  z-index: 1;
  padding: 50px 32px 50px 0;
  width: 100%;
  color: white;
}

.descriptions-mobile-slide {
  width: 350px;
  height: 350px;
}

.descriptions-mobile-slide-first {
  padding-left: 16px;
  box-sizing: content-box;
}

.descriptions-mobile-slide-last {
  padding-right: 16px;
  box-sizing: content-box;
}
</style>
